import { render, staticRenderFns } from "./ChannelSelectionModal.vue?vue&type=template&id=fab6f6a6&scoped=true"
import script from "./ChannelSelectionModal.vue?vue&type=script&lang=js"
export * from "./ChannelSelectionModal.vue?vue&type=script&lang=js"
import style0 from "./ChannelSelectionModal.vue?vue&type=style&index=0&id=fab6f6a6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab6f6a6",
  null
  
)

export default component.exports